import { AtMaturityPeriod, PERIODIC_PERIOD_VALUES } from '@src/types/OTC/loanSchedulePeriod';
import { LoanPaymentTypeEnum, LoanQuoteTerminationTypeEnum } from '@talos/kyoko';
import { string } from 'yup-v1-latest';
import { getLoanSchedulePeriodRank, isPeriodicPeriod } from './loanPaymentType';

const isBulletPaymentType = (value: string | undefined): boolean => value === LoanPaymentTypeEnum.Bullet;

export const loanPaymentTypeSchema = string()
  .oneOf([LoanPaymentTypeEnum.Periodic, LoanPaymentTypeEnum.Bullet] as const)
  .default(LoanPaymentTypeEnum.Periodic);

export const loanTermTypeSchema = string()
  .oneOf([LoanQuoteTerminationTypeEnum.Fixed, LoanQuoteTerminationTypeEnum.OpenTerm] as const)
  .required('Term type is required')
  .test('bullet-requires-fixed-term', 'Bullet loans require a Fixed term', function (value) {
    if (this.parent.loanPaymentType !== LoanPaymentTypeEnum.Bullet) {
      return true;
    }
    return value === LoanQuoteTerminationTypeEnum.Fixed;
  });

export const loanPaymentPeriodSchema = string()
  .required('Payment period is required')
  .when('loanPaymentType', {
    is: isBulletPaymentType,
    then: schema => schema.oneOf([AtMaturityPeriod], 'Bullet loans use At Maturity for payment period'),
    otherwise: schema => schema.oneOf([...PERIODIC_PERIOD_VALUES], 'Invalid Payment period symbol'),
  });

export const loanAccrualPeriodSchema = string()
  .required('Accrual period is required')
  .when('loanPaymentType', {
    is: isBulletPaymentType,
    then: schema => schema.oneOf([AtMaturityPeriod], 'Bullet loans use At Maturity for accrual period'),
    otherwise: schema =>
      schema
        .oneOf([...PERIODIC_PERIOD_VALUES], 'Invalid Accrual period symbol')
        .test('accrual-leq-payment', 'Accrual period must be less than or equal to payment period', function (value) {
          const paymentPeriod = this.parent.paymentPeriod;
          if (!isPeriodicPeriod(value) || !isPeriodicPeriod(paymentPeriod)) {
            return false;
          }
          return getLoanSchedulePeriodRank(value) <= getLoanSchedulePeriodRank(paymentPeriod);
        }),
  });
